/**
 * Campaign field of the Traffic link dialog: Voluum and Binom keep the free-text
 * id input exactly as it was; Tres Commas picks from its campaign list.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import { assertNever } from '@trafficpulse/shared';

import { Input } from '@/components/ui';
import type { PatchTrafficProvider } from '@/hooks';

import { campaignIdPlaceholder } from './link-choices';
import { TresCommasCampaignSelect } from './TresCommasCampaignSelect';

interface TrafficCampaignFieldProps {
  provider: PatchTrafficProvider;
  value: string;
  onChange: (campaignId: string) => void;
  disabled: boolean;
}

const CampaignIdInput: FC<TrafficCampaignFieldProps> = ({ provider, value, onChange, disabled }) => (
  <div className="space-y-1.5">
    <label htmlFor="traffic-campaign-id" className="text-sm font-medium">
      Campaign id
    </label>
    <Input
      id="traffic-campaign-id"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={campaignIdPlaceholder(provider)}
      disabled={disabled}
      autoComplete="off"
    />
  </div>
);

export const TrafficCampaignField: FC<TrafficCampaignFieldProps> = (props) => {
  switch (props.provider) {
    case 'VOLUUM':
    case 'BINOM':
      return <CampaignIdInput {...props} />;
    case 'TRES_COMMAS':
      return <TresCommasCampaignSelect value={props.value} onChange={props.onChange} disabled={props.disabled} />;
    default:
      return assertNever(props.provider, 'traffic provider');
  }
};
